import { Logout } from '@mui/icons-material'
import { Grid, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material'
import Avatar from 'boring-avatars'
import { useAuth } from 'context'
import { SyntheticEvent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

//  Summary
//  Display's the current user's profile image with options for punching in/out, creating suggestions, and signing out.
export default function User() {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()

  const [anchorEl, setAnchorEl] = useState<Element | null>(null)

  const onClickUserProfile = (event: SyntheticEvent) => {
    setAnchorEl(event.currentTarget)
  }

  const onCloseUserProfileMenu = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (anchorEl && !anchorEl.contains(event.target as Node)) {
        onCloseUserProfileMenu()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [anchorEl])

  return (
    <>
      <Grid container alignItems='center' justifyContent='flex-end'>
        <Grid item>
          <Typography color='white'>
            {user?.firstName} {user?.lastName}
          </Typography>
        </Grid>

        <Grid item xs='auto' onClick={onClickUserProfile} sx={{ cursor: 'pointer' }}>
          <Avatar
            size='40'
            square={false}
            name={user?.firstName + ' ' + user?.lastName}
            variant='beam'
            colors={['#010D26', '#023E73', '#055BA6', '#A0CCF2', '#B57114']}
          />
        </Grid>
      </Grid>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)}>
        {/*
        I originally planned to handle an edge case described in
        "R22 - Entry # and Entry Date - Design Signed 20260720.pdf":
        If a user has the Conformity Add/Edit permission but not the People Add/Edit permission,
        they have no way to upload their own Statement of Conformity Signature.
        Per a discussion with Matthew Regan on 2026-07-28, this is expected behavior.
        If the user does not have a signature uploaded, the API will return a Bad Request response.
        Maxwell Sommer 2026-07-28
        */}
        {/* <MenuItem
          onClick={() => {
            navigate(`/people/${user?.personGuid}`)
          }}
          dense
        >
          <ListItemText primaryTypographyProps={{ color: 'primary', fontSize: '10pt', fontWeight: 'bold', marginRight: 1 }}>My Account</ListItemText>

          <ListItemIcon>
            <AccountCircle color='primary' />
          </ListItemIcon>
        </MenuItem> */}

        <MenuItem onClick={signOut} dense>
          <ListItemText primaryTypographyProps={{ color: 'primary', fontSize: '10pt', fontWeight: 'bold', marginRight: 1 }}>Sign Out</ListItemText>

          <ListItemIcon>
            <Logout color='primary' />
          </ListItemIcon>
        </MenuItem>
      </Menu>
    </>
  )
}
